import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HelpModalModule } from 'Angular/features/components/modals/help-modal/help-modal.module';
import { AppendToBodyModule } from 'Angular/features/directives/append-to-body/append-to-body.module';
import { DisabledModule } from 'Angular/features/directives/disabled/disabled.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import * as i0 from "@angular/core";
export class SingleSelectDropdownModule {
}
SingleSelectDropdownModule.ɵfac = function SingleSelectDropdownModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SingleSelectDropdownModule)(); };
SingleSelectDropdownModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SingleSelectDropdownModule });
SingleSelectDropdownModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, DisabledModule, FeatureNeededModule, FormsModule, HelpModalModule, AppendToBodyModule] });
